import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { CanvasState } from '../CanvasState';

export const useInitialiseCanvas = () => {
  const { dispatch } = useWorkFlowCanvas();

  return useCallback(
    ({ nodes, edges, showIntroVariant }: CanvasState) => {
      dispatch({
        type: 'INIT',
        payload: {
          nodes,
          edges,
          showIntroVariant,
        },
      });
    },
    [dispatch],
  );
};
